import React from 'react'
import Relay from 'react-relay'
import Input from './TextField'
import { colors } from '../theme'
import Radium from 'radium'

export const getOptionsFromUsers = (users) => users && users.edges.length && users.edges.map((edge) => ({
  value: edge.node.id, label: edge.node.pseudo, user: edge.node,
}))

const emailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
export const isValidEmailAddress = (address) => emailRegex.test(address)

const ADMIN_LEVEL = 'ADMIN'

const pipe = (fns) => (arg) => fns.reduce((arg, nextF) => nextF(arg), arg)

const projection = (config) => (target) =>
  Object
    .keys(config)
    .reduce((mem, field) => ({
      ...mem,
      [field]: typeof config[field] === "function" ? config[field](target) : target[field],
    }), {})

const appendAuthorized = (authorized_managers, user) => [
  ...(authorized_managers.map(projection({authorization_level: true, user: (t) => t.user.id}))),
  { authorization_level: ADMIN_LEVEL, user: user.id }
]

const notThisUser = (user) => (options) =>
  (options || []).filter((option) => user.id !== option.user.id)

const notThoseUsers = (users) => (options) =>
  users.reduce((options, user) => notThisUser(user)(options), options)

const getOptionsFromUsersWithoutThisUser = (notUsers) => pipe([
  getOptionsFromUsers,
  notThoseUsers(notUsers),
])

class SelectUser extends React.Component {

  state = {
    inputContent: '',
    open: true,
    autocompleteUsersQuery: '',
    autocompleteUserSelected: null,
  }

  componentWillMount() {
    this.getOptionsFromUsers = getOptionsFromUsersWithoutThisUser(this.props.notUsers)
  }

  _handleUserSearchInput = (inputContent) => {
    clearTimeout(this._handleUserSearchInput.timeout)
    const fireIt = () => this._handleAutocompleteUserQueryChange(inputContent)
    this._handleUserSearchInput.timeout = setTimeout(fireIt, 400)
  }

  _handleAutocompleteUserQueryChange = (query) => {
    const isEmail = isValidEmailAddress(query)
    this.props.relay.setVariables({
      pseudo_autocomplete: !isEmail? query : null,
      email_autocomplete: isEmail? query : null,
      autocompletion_required: true,
    })
  }

  _handleUserSearchSelection = (option) => this.setState({
    autocompleteEmail: '',
    autocompletePseudo: option && option.label,
    autocompleteUserSelected: option && option.user,
    autocompleteUsersQuery: option.label,
  }, () => {
    this.props.onSelectedUser(this.state.autocompleteUserSelected)
  })

  renderOption = (option) => (
		<div style={{ display: 'flex', flexDirection: 'row'}}>
      <img src={option.user.avatar} style={{ height: 20, width: 'auto', padding: 4, verticalAlign: 'middle' }} />
      {option.label}
    </div>
	)

  render() {
    const { onSelectedUser, viewer } = this.props
    const { selectAutocompleteUsers: users } = viewer

    return (
      <Input
        edit={true}
        options={this.getOptionsFromUsers(this.props.viewer.selectAutocompleteUsers)}
        value={this.state.autocompleteUsersQuery}
        fieldName="Select a User"
        placeholder='Link to account'
        onChange={this._handleUserSearchSelection}
        onInputChange={this._handleUserSearchInput}
        optionRenderer={this.renderOption}
        type="select"
      />
    )
  }

}

const styles = {
  list: {

  },
  listItemClickable: {
      paddingBottom: 10,
      color: '#515151',
      fontSize: 20,
      fontWeight: 500,
      fontFamily: 'Lato',
      borderBottomWidth: 1,
      borderColor: colors.blue,
      borderStyle: 'solid',
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'baseline',
      marginBottom: 5,
      cursor: 'pointer'
  },
}

export default Relay.createContainer(Radium(SelectUser), {
    initialVariables: {
        pseudo_autocomplete: '_',
        email_autocomplete: null,
        autocompletion_required: false
    },
    fragments: {
        viewer: () => Relay.QL`
      fragment on Viewer {
        selectAutocompleteUsers: users (pseudo: $pseudo_autocomplete, email: $email_autocomplete, last: 5) @include(if: $autocompletion_required) {
          edges {
            node {
              id
              pseudo
              avatar
            }
          }
        }
        me {
          id
        }
      }
    `,
    },
})



// WEBPACK FOOTER //
// ./src/components/SelectUser.js